module.exports = __webpack_public_path__ + "a17d279f/img/placeholder.888fcd0b.svg";